import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "numex_admin_token";

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (e) {
    return null;
  }
};
export const setToken = (t) => {
  try {
    localStorage.setItem(TOKEN_KEY, t);
  } catch (e) {
    /* ignore */
  }
};
export const clearToken = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch (e) {
    /* ignore */
  }
};

const auth = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong.";
}

export async function adminLogin(username, password) {
  const { data } = await axios.post(`${API}/admin/login`, { username, password });
  setToken(data.token);
  return data;
}
export async function adminMe() {
  const { data } = await axios.get(`${API}/admin/me`, auth());
  return data;
}
export async function listPuzzles() {
  const { data } = await axios.get(`${API}/admin/puzzles`, auth());
  return data.puzzles;
}
export async function editPuzzle(n, body) {
  const { data } = await axios.put(`${API}/admin/puzzles/${n}`, body, auth());
  return data;
}
export async function regeneratePuzzle(n) {
  const { data } = await axios.post(`${API}/admin/puzzles/${n}/regenerate`, {}, auth());
  return data;
}
export async function generateBuffer() {
  const { data } = await axios.post(`${API}/admin/generate`, {}, auth());
  return data;
}
export async function changePassword(body) {
  const { data } = await axios.post(`${API}/admin/change-password`, body, auth());
  return data;
}
export async function changeUsername(body) {
  const { data } = await axios.post(`${API}/admin/change-username`, body, auth());
  if (data.token) setToken(data.token);
  return data;
}
